export default __webpack_public_path__ + "static/16-7af4b6c09d147f68489198afb3ef8d38.jpg";